import { createIcons, Cog, AlarmClock, Info, Eye, CircleX, EllipsisVertical} from 'lucide';

// Create icons on ajax content load
document.addEventListener('ajaxContentLoaded', () => {
    createIcons({
        icons: {
            Cog,
            AlarmClock,
            Info,
            Eye,
            CircleX,
            EllipsisVertical
        },
        defaultProps: {
            'stroke-width': 1.5,
            stroke: '#bbbbbb'
        }
    });

    document.dispatchEvent(new CustomEvent('iconsCreated'));
});